$(document).ready(function(){

    const scheduleCalendareList = $('.schedule-calendare__list');
    const getScheduleButton = $('.js-get-schedule');
    const scheduleCalendareGroup = $('.schedule-calendare__calendar').attr('data-homework-group');
    let eventsData = [];

    eventsData = [
        // {
        //     date_from: "07.08.2022 11:00",
        //     date_to: "08.08.2022 14:00",
        //     end: "2022-08-08T14:00:00",
        //     start:"2022-08-07T11:00:00",
        //     name: "Описание задания"
        // },
        // {
        //     end: "2022-08-08T14:00:00",
        //     hall: "2",
        //     homework: "Домашнее задание",
        //     schedule_date: "01.09.2022",
        //     schedule_time: "2",
        //     start: "2022-08-07T11:00:00",
        //     students: "11",
        //     teacher: "6",
        //     title: "Тема",
        // }
    ]

    getScheduleButton.on('click', function () {
        const id = $(this).attr('data-schedule-id');

        $.ajax({
            type: "GET",
            url: `/ajax/schedule?id=${id}`,
            success: function (data) {
                eventsData = data;

                console.log(333, data);
                let calendar = new Calendar({
                    id: "#color-calendar",
                    calendarSize: "large",
                    theme: "glass",
                    headerColor: "#ffffff",
                    headerBackgroundColor: "#27a0f3",
                    startWeekday: 1,
                    customMonthValues: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                    customWeekdayValues: ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
                    monthChanged: () => {
                        console.log(111, 'changed month')
                    },
                    dateChanged: (currentDate, events) => {
                        scheduleCalendareList.empty()
                        if (!events.length) {
                            scheduleCalendareList[0].insertAdjacentHTML('beforeend', `
                                <div class="schedule-calendare__no">
                                    На выбранную дату задания нет.
                                </div>
                            `)
                        } else {
                            events.map(function (item) {
                                scheduleCalendareList[0].insertAdjacentHTML('beforeend', `
                                    <div class="schedule-calendare__item">
                                        <p class="schedule-calendare__title">
                                            Тема:
                                        </p>
                                        <p class="schedule-calendare__description">
                                            ${item.title}
                                        </p>
                                        <p class="schedule-calendare__title">
                                            Дата:
                                        </p>
                                        <div class="schedule-calendare__description">
                                            ${item.schedule_date}
                                        </div>
                                        <p class="schedule-calendare__title">
                                            Время:
                                        </p>
                                        <div class="schedule-calendare__description schedule-calendare__date--mb8">
                                            ${item.schedule_time}
                                        </div>
                                        ${item.homework &&
                                            `
                                                <p class="schedule-calendare__title">
                                                    Домашнее задание:
                                                </p>
                                                <p class="schedule-calendare__description">
                                                    ${item.homework}
                                                </p>
                                            `
                                        }
                                        ${item.teacher &&
                                            `
                                                <p class="schedule-calendare__title">
                                                    Преподаватель:
                                                </p>
                                                <p class="schedule-calendare__description">
                                                    ${item.teacher}
                                                </p>
                                            `
                                        }
                                        ${item.homework &&
                                            `
                                                <p class="schedule-calendare__title">
                                                    Зал:
                                                </p>
                                                <p class="schedule-calendare__description">
                                                    ${item.hall}
                                                </p>
                                            `
                                        }
                                    </div>
                                `)
                            });
                        }
                    },
                    eventsData: eventsData
                });
            }
        });
    })

    // if (location.href.indexOf('schedule')) {
    //     getEventsData();
    // }
});
